module.exports = __webpack_public_path__ + "img/photography.f5d84c22.jpg";